import React from 'react'
import styled from 'styled-components'
import { Container, Kicker, MOBILE } from '../CustomLanding.styled'
import { colors, method } from '../content'

const MethodSteps: React.FC = () => (
	<Section id="method">
		<Container>
			<Kicker>{method.kicker}</Kicker>
			<Title>{method.title}</Title>
			<Steps>
				{method.steps.map(step => (
					<StepCard key={step.num}>
						<StepNum>{step.num}</StepNum>
						<StepBody>
							<StepTitle>{step.title}</StepTitle>
							<StepText>{step.text}</StepText>
						</StepBody>
					</StepCard>
				))}
			</Steps>
			<GoalBox>
				<GoalTitle>{method.goalTitle}</GoalTitle>
				<GoalBody>
					<GoalIntro>{method.goalIntro}</GoalIntro>
					<GoalQuote>{method.goalQuote}</GoalQuote>
					<GoalIntro>{method.goalNot}</GoalIntro>
					<GoalStruck>
						{method.goalStruck}
						<Emoji>{method.goalStruckEmoji}</Emoji>
					</GoalStruck>
				</GoalBody>
			</GoalBox>
		</Container>
	</Section>
)

export default MethodSteps

const Section = styled.section`
	background: ${colors.paper};
	padding: 64px 0;
	${MOBILE} {
		padding: 40px 0;
	}
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 32px;
	${MOBILE} {
		font-size: 28px;
		line-height: 1.4;
		margin-bottom: 26px;
	}
`

const Steps = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	gap: 24px;
	margin-bottom: 40px;
	${MOBILE} {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 24px;
	}
`

const StepCard = styled.div`
	background: #ffffff;
	border: 1px solid ${colors.line};
	border-radius: 20px;
	padding: 32px 28px 34px;
	${MOBILE} {
		border-radius: 18px;
		padding: 22px;
		display: flex;
		gap: 16px;
		align-items: flex-start;
	}
`

const StepNum = styled.div`
	font-weight: 800;
	font-size: 15px;
	letter-spacing: 0.06em;
	color: ${colors.blue};
	margin-bottom: 20px;
	direction: ltr;
	text-align: right;
	${MOBILE} {
		font-size: 14px;
		margin-bottom: 0;
		flex: 0 0 auto;
		padding-top: 5px;
	}
`

const StepBody = styled.div``

const StepTitle = styled.h3`
	font-weight: 700;
	font-size: 22px;
	color: ${colors.navy};
	margin: 0 0 12px;
	${MOBILE} {
		font-size: 22px;
		margin-bottom: 6px;
	}
`

const StepText = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: 1.9;
	color: ${colors.muted};
	${MOBILE} {
		font-size: 15px;
		line-height: 1.85;
	}
`

const GoalBox = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 32px 56px;
	align-items: center;
	background: #ffffff;
	border: 1px solid ${colors.line};
	border-radius: 24px;
	padding: 36px 36px;
	${MOBILE} {
		display: block;
		border-radius: 20px;
		padding: 28px 22px;
	}
`

const GoalTitle = styled.h3`
	font-weight: 700;
	font-size: clamp(22px, 1.8vw, 28px);
	color: ${colors.navy};
	margin: 0;
	white-space: nowrap;
	flex: 0 0 auto;
	${MOBILE} {
		font-size: 24px;
		margin-bottom: 16px;
	}
`

const GoalBody = styled.div`
	flex: 1 1 320px;
	min-width: 0;
`

const GoalIntro = styled.p`
	margin: 0 0 18px;
	font-size: 17px;
	color: ${colors.muted};
	line-height: 1.8;
	${MOBILE} {
		font-size: 15px;
		margin-bottom: 14px;
	}
`

const GoalQuote = styled.p`
	margin: 0 0 26px;
	font-weight: 700;
	font-size: clamp(19px, 1.6vw, 24px);
	line-height: 1.6;
	color: ${colors.navy};
	border-inline-start: 4px solid ${colors.amber};
	padding-inline-start: 20px;
	${MOBILE} {
		font-size: 21px;
		padding-inline-start: 16px;
		margin-bottom: 20px;
	}
`

const GoalStruck = styled.p`
	margin: 0;
	font-size: 17px;
	line-height: 1.8;
	color: #9aa3b5;
	text-decoration: line-through;
	text-decoration-color: rgba(251, 54, 64, 0.5);
	text-decoration-thickness: 2px;
	${MOBILE} {
		font-size: 16px;
	}
`

const Emoji = styled.span`
	text-decoration: none;
	display: inline-block;
`
